"use client";

import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import React from "react";

/** @optimized using svgo:^3.0.2 */
export const EcoFriendly = createSVGIcon(
  <>
    <path
      d="M1.032 1S-.244 15.446 13.317 15.854c0 0 3.91-12.814-12.285-14.854ZM1 1l14.146 16.976M29.968 1s1.276 14.446-12.285 14.854c0 0-3.91-12.814 12.285-14.854Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30 1 15.146 18.091v4.836M4.537 22.928h21.926l-.73 4.951H5.755z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m7.366 27.879 1.787 11.317h13.32l1.869-11.317"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "EcoFriendly",
  { viewBox: "0 0 31 40", titleAccess: "EcoFriendly", fill: "none" }
);
